import { RelayEnvironmentProvider, useRelayEnvironment } from "react-relay";

import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";

import { MemberModalContent } from "./components/MemberModalContent";

export const MemberListModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const relayEnvironment = useRelayEnvironment();
  return (
    <StandardModal
      lockFullHeight
      isOpen={isOpen}
      onClose={onClose}
      content={
        <RelayEnvironmentProvider environment={relayEnvironment}>
          <MemberModalContent isOpen={isOpen} />
        </RelayEnvironmentProvider>
      }
      disableContentScroll={true}
    />
  );
};
